export enum MagicFieldProperties {
  MONEY_CURRENCY_CODE = "money.currency.code",  // e.g. INR
}
